import { makeStyles } from '@mui/styles';
import { theme } from 'components/Shared/ThemeProviderWrapper';
import { colors, fonts } from 'components/styles/variables';

export const styles = makeStyles(() => ({
  mobileFilter: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  ctaRow: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '8px',
    [theme.breakpoints.up('sm')]: {
      background: 'white',
      justifyContent: 'space-between',
      padding: '8px',
      '& button': {
        width: '135px',
      },
    },
  },
  clearFilterButton: {
    border: `1px solid ${colors.G2}`,
    color: colors.BLACK,
    fontFamily: fonts.default,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.2px',
    textTransform: 'none',
    borderRadius: '4px',
  },
  mobileDrawer: {
    padding: '0 0 16px 0',
    justifyContent: 'space-around',
    '& button': {
      width: 'calc((100% - 48px) / 2)',
    },
  },
}));
